import React from 'react';
import {Typography} from "@mui/material";
import {styled} from "@mui/styles";

const Root = styled(Typography)(() => ({
  color: '#00000061',
  textTransform: 'uppercase',
  whiteSpace: 'normal',
}))

type CollapsableCardLabelProps = React.ComponentPropsWithoutRef<'span'>

/**
 * MUI Typography component styled in the SecurSpace way. For use inside the CollapsableCard component suite as the descriptor for subsequent value components
 * @param children children passed through to the internal Typography component
 * @param rest The rest of the Typography props that will be passed through to the internal Typography component
 * @constructor
 */
const CollapsableCardLabel = ({children, ...rest}: CollapsableCardLabelProps) => {
  return <Root variant={'body2'} {...rest}>
    { children }
  </Root>
}

export { CollapsableCardLabel };
